import axios from "axios";

// In Hostinger production deploys, set REACT_APP_BACKEND_URL="" so API becomes
// a relative "/api" path served by the same origin (PHP backend via .htaccess).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Track refresh promise to avoid concurrent refresh calls
let refreshPromise = null;

// 401 interceptor — automatically retry with refresh token.
// Only redirects to login when the user was on a protected page
// (avoids redirect loops on /login, /register, and /).
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Don't retry auth endpoints
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/")
    ) {
      originalRequest._retry = true;

      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").then(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
        return api(originalRequest);
      } catch {
        refreshPromise = null;
        // Only hard-redirect if on a protected page (not login/register/landing)
        const path = window.location.pathname;
        if (path !== "/" && path !== "/login" && path !== "/register" && !path.startsWith("/invite/")) {
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
